import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import a1fe5175a4b80f9718364af00817e1f2bb from "./generated-7dba8ef8-8193-4bef-a140-623720811a72.json";

import aebadc95456d272f4f2c0861ee0b0847eb from "./generated-31e217fa-a3c4-4bb0-b3d1-516c33a53115.json";

import a58ae6b768144eedc676596438b6f6348b from "./generated-fdd7e3bd-7d31-44b8-a70d-d2b2a6a39033.json";

import a29075d934ecc3028a245f07a0f5b07cfb from "./generated-6c71ef56-ffdf-4da0-8de9-e70f90d41094.json";

import aa164455b5ec2565adf6db6ddbece1f2cb from "./generated-c6fea9a7-8ddd-4d67-8c06-a3bf02c69a15.json";

import aa6265ad3ee2996e2f2ccb005b4fb215eb from "./generated-684e97d1-c6a3-4c57-9116-67665c71f57c.json";

import a3ddcf944c7c7e727e7dca14bc1038711b from "./generated-f02c1629-7c5f-4833-8056-99b9d43b417e.json";

import ab6d840fdcd0f569a3031e8905ba41a4bb from "./generated-37bf1ce9-06eb-48f2-9ef9-0bac6e053b88.json";

import ac5dfd4c134dd2d69dc8992fad560edf1b from "./generated-1bfbbcec-6a29-4713-8834-c4ecaec2a1ea.json";

import a176426995544378949a233703e87fbb9b from "./generated-87e504e4-1892-4cc8-9331-61cf28e5f937.json";

import affc4df76c1cf9d4651a8fbd8d5372f67b from "./generated-d7aa3e0f-1905-44cb-bbd4-5d5625589a30.json";

import ad3570ed0516cae4460ecff641ef0dd84b from "./generated-de8d7c51-c66d-4ce3-8ce1-c9232a9d5a6c.json";

import a44fe1de6829b03dd0d50081dc9b68b8eb from "./generated-d42caaa4-2373-4370-bcc4-e29cdfe7ea59.json";

import a6854ecf40f491d2de18c8ba170a10533b from "./generated-7cbce9e4-dbfe-4887-bc3c-7c294b53e36e.json";

import a06504cd7b986b8cf05b23a5c23e8dc5bb from "./generated-284d9c86-c6c0-442f-9ede-a1fc39b4aeeb.json";

import a6fb6e487f70bf17c44a7d7b8b0a88efbb from "./generated-028d2c9a-774a-43a0-80c2-ef80064eac6e.json";

import ac37e8622f5541acc28b65a1b0e707f91b from "./generated-9804b16c-3b76-46df-b601-244eda2e9249.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(a1fe5175a4b80f9718364af00817e1f2bb);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(aebadc95456d272f4f2c0861ee0b0847eb);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a58ae6b768144eedc676596438b6f6348b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(a29075d934ecc3028a245f07a0f5b07cfb);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(aa164455b5ec2565adf6db6ddbece1f2cb);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(aa6265ad3ee2996e2f2ccb005b4fb215eb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(a3ddcf944c7c7e727e7dca14bc1038711b);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(ab6d840fdcd0f569a3031e8905ba41a4bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(ac5dfd4c134dd2d69dc8992fad560edf1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a176426995544378949a233703e87fbb9b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(affc4df76c1cf9d4651a8fbd8d5372f67b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(ad3570ed0516cae4460ecff641ef0dd84b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(ac5dfd4c134dd2d69dc8992fad560edf1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a44fe1de6829b03dd0d50081dc9b68b8eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a6854ecf40f491d2de18c8ba170a10533b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(ac5dfd4c134dd2d69dc8992fad560edf1b);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(a06504cd7b986b8cf05b23a5c23e8dc5bb);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(a6fb6e487f70bf17c44a7d7b8b0a88efbb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(ac37e8622f5541acc28b65a1b0e707f91b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(a06504cd7b986b8cf05b23a5c23e8dc5bb);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */